module.exports = {
  id: 'seven',
  cellwidth: 7,
  cellheight: 9,
  charwidth: 5,
  charheight: 7,
  charspace: 1,
  wordspace: 3,
  linespace: 5,
  exceptions: {
    1: { width: 3 },
    I: { width: 3 },
    f: { width: 4 },
    g: { height: 9 },
    i: { width: 1 },
    j: { width: 2, height: 8 },
    k: { width: 4 },
    l: { width: 1, x: 0 },
    m: { width: 7 },
    p: { height: 9 },
    q: { height: 9 },
    r: { width: 4 },
    t: { width: 4 },
    w: { width: 7 },
    y: { height: 9 },
    ',': { width: 2, height: 9 },
    '.': { width: 1 },
    '!': { width: 1 },
    '\'': { width: 1 },
    '(': { width: 3 },
    ')': { width: 3 }
  },
  layout: [
    '0123456789',
    'ABCDEFGHIJ',
    'KLMNOPQRST',
    'UVWXYZ,.!?',
    'abcdefghij',
    'klmnopqrst',
    'uvwxyz\'()'
  ]
}
